
<label class="text-sm fw-500" [for]="inputId">
  {{ label }}
  <span *ngIf="isRequired"class="red-astrick">*</span>
  <img
  *ngIf="noteText"
    [matTooltip]="noteText"
    fetchpriority="high"
    width="12"
    height="12"
    src="images/info_icon.svg"
    [alt]="noteText"
  />
</label>
